import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, UUID, DATETIME, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Scan from './Scan'
import Level from './Level'
import Item from '../Consignment/Item'
import Consignment from '../Consignment'
import CustomerIOLog from '../CustomerIOLog'
import MessageBirdLog from '../MessageBirdLog'

export default class extends Resource {
  static name = 'tracking'

  static get fields () {
    return {
      id: new UUID(),
      manually_created: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_date: new DATETIME(),
      level: new ITEM(Level),
      consignment_item: new ITEM(Item),
      consignment: new ITEM(Consignment),
      scan: new ITEM(Scan),
      emails: new COLLECTION(CustomerIOLog),
      sms: new COLLECTION(MessageBirdLog)
    }
  }
}
